export default "__VITE_ASSET__Bh9_otC$__"